import * as yup from 'yup';
export const createMerchantGroupSchema = yup
    .object({
    name: yup.string().required(),
    active: yup.boolean().required(),
    merchantIds: yup.array().of(yup.string()).optional(),
    userIds: yup.array().of(yup.string()).required(),
    tenantId: yup.string().optional(),
})
    .required();
export const updateMerchantGroupSchema = yup.object({
    groupId: yup.string().required(),
    isActive: yup.boolean().required(),
    name: yup.string().required(),
    userIds: yup.array().of(yup.string()).optional(),
    merchantIds: yup.array().of(yup.string()).optional(),
});
//# sourceMappingURL=merchantGroup.js.map